<template>
    <el-select v-if="clear == 'noclear'" v-model="appObjJson" value-key="appId" size="small" filterable placeholder="请选择小程序" style="width: 200px;"
        @change="handleChange">
        <el-option v-for="(item, index) in appOptions" :key="index" :label="item.name" :value="item">
        </el-option>
    </el-select>
    <!--<el-select v-else v-model="appIdson" filterable clearable placeholder="请选择小程序" style="width: 200px;"-->
        <!--@change="handleChange()">-->
        <!--<el-option v-for="item in appOptions" :key="item.appId" :label="item.name" :value="item.appId">-->
        <!--</el-option>-->
    <!--</el-select>-->
</template>
<script>
// import { getAppList } from "@/api/dysvzk/base/get";
export default {
    name: 'AppList',
    props: ['appObj', 'clear', 'appList'],
    data() {
        return {
            appObjJson: {},
            appOptions: [
                {
                    appId: '',
                    name: ''
                }
            ]
        }
    },
    watch: {
        appObj(newValue) {
            this.appObjJson = newValue
        },
        appObjJson(newValue) {
            this.$emit('update:appObj', newValue);
        }
    },
    mounted: function () {
        this.appObjJson = this.appObj
        console.log('app组件', this.appObjJson)
        // this.getList()
        if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
            console.log(JSON.parse(localStorage.getItem('accountInfo')))
            this.appOptions = [
                {
                    appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
                    name: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName
                }
            ]
            this.appObjJson = {
                appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
                name: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName
            }
            console.log(this.appOptions)
        } else {
            this.appOptions = JSON.parse(localStorage.getItem('appList'))
        }
    },
    methods: {
        handleChange(val) {
            console.log("data", val)
            // this.$emit('getAppId', val);
            this.$emit('getAppId', this.appObj);
            localStorage.setItem('appId', val.appId)
            localStorage.setItem('appName', val.name)
            localStorage.setItem('appObj', JSON.stringify(val))
            window.location.reload()
        }
        // getList() {
        //     getAppList({
        //         pageNo: 1,
        //         pageSize: 100
        //     }).then(response => {
        //         if (response.data.head.flag === 0) {
        //             this.appOptions = response.data.content
        //         } else {
        //             this.$message.error(response.data.head.desc)
        //         }
        //     });
        // },
    }
}
</script>
